import { Autocomplete, Button, DateRange, Field, Filter, SearchField } from "components/commons";
import React from "react";
import styles from "../non-fuel-filter.module.scss";
import locale from "localization";
import { prettifySettlementStatus } from "utils";
import { SettlementStatus } from "enums";
import { prettifyPayWithPesoStatus } from "utils/pretty.utils";
import PayWithPesoStatus from "enums/pay-with-peso-status";
import { SelectStationNonFuel } from "components/field";

const NonFuelFilterPLB = ({
  filterState,
  applyFilter,
  applyClearFilter,
  applyResetFilter,
  modifyFilter,
  modifySearch,
  applySearch,
  applyClearSearch,
  searchKey,
  filterCount,
  exportReport,
  exporting,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.filter}>
        <Filter
          submit={applyFilter}
          clear={applyClearFilter}
          close={applyResetFilter}
          filterCount={filterCount}
        >
          <Field
            className={styles.date}
            labelPosition={"left"}
            label={locale.transactionDate}
            childrenClassName={styles.fieldContent}
          >
            <DateRange
              value={{
                startDate: filterState.startDate,
                endDate: filterState.endDate,
              }}
              onChange={(_, { value }) => {
                const { startDate, endDate } = value;
                modifyFilter({
                  startDate,
                  endDate,
                });
              }}
            />
          </Field>
          <Field
            label={locale.status}
            labelPosition={"left"}
            className={styles.fieldSelect}
            childrenClassName={styles.fieldContent}
          >
            <Autocomplete
              name={"status"}
              value={filterState.status.value}
              hasAll
              multiple
              options={[
                {
                  label: prettifyPayWithPesoStatus(PayWithPesoStatus.Success),
                  value: PayWithPesoStatus.Success,
                },
                {
                  label: prettifyPayWithPesoStatus(PayWithPesoStatus.Voided),
                  value: PayWithPesoStatus.Voided,
                },
              ]}
              onChange={(name, { value, isSelectedAll }) => {
                modifyFilter({ [name]: { value, isSelectedAll } });
              }}
            />
          </Field>
          <Field
            label={locale.settlementStatus}
            labelPosition={"left"}
            className={styles.fieldSelect}
            childrenClassName={styles.fieldContent}
          >
            <Autocomplete
              name={"settlementStatuses"}
              value={filterState.settlementStatuses.value}
              hasAll
              multiple
              options={[
                {
                  label: prettifySettlementStatus(SettlementStatus.ForProcessing),
                  value: SettlementStatus.ForProcessing,
                },
                {
                  label: prettifySettlementStatus(SettlementStatus.ForSettlement),
                  value: SettlementStatus.ForSettlement,
                },
                {
                  label: prettifySettlementStatus(SettlementStatus.Processed),
                  value: SettlementStatus.Processed,
                },
              ]}
              onChange={(name, { value, isSelectedAll }) => {
                modifyFilter({ [name]: { value, isSelectedAll } });
              }}
            />
          </Field>
          <Field
            labelPosition={"left"}
            childrenClassName={styles.fieldContent}
            label={locale.gasUpStation}
            className={styles.filterInput}
          >
            <SelectStationNonFuel
              {...filterState?.redemptionStation}
              onChange={(_, { value, label }) => {
                modifyFilter({ redemptionStation: { value, label } });
              }}
            />
          </Field>
        </Filter>
        <Field className={styles.search}>
          <SearchField
            restrict={false}
            searchWithSymbols
            placeholder={locale.nonFuelSearch}
            value={searchKey}
            onChange={(_, { value }) => {
              modifySearch(value);
            }}
            onEnter={applySearch}
            onClear={applyClearSearch}
          />
        </Field>
        <Field className={styles.downloadButton}>
          <Button
            startIcon={<span className="icon-download" />}
            exportButton
            onClick={exportReport}
            disabled={exporting}
            loading={exporting}
          >
            {locale.export}
          </Button>
        </Field>
      </div>
    </div>
  );
};

export default NonFuelFilterPLB;
